"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassName = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _utility = require("react-suitcssify/dist/lib/utility");

var _utilityConfiguration = require("@wel-ui/utility-configuration");

var _utilityConfiguration2 = _interopRequireDefault(_utilityConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getClassName = function getClassName(args) {
  return (0, _utility.getClassName)((0, _extends3.default)({
    namespace: _utilityConfiguration2.default.current.styles.namespace
  }, args));
};

var getClassNameFactory = function getClassNameFactory(componentName) {
  return function (args) {
    return getClassName((0, _extends3.default)({
      componentName: componentName
    }, args));
  };
};

exports.default = getClassNameFactory;
exports.getClassName = getClassName;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/utility-class-names/lib/index.js
// module id = 7
// module chunks = 0